export const ArIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path
        d="M2.5 5.83333V4.16667C2.5 3.72464 2.67559 3.30072 2.98816 2.98816C3.30072 2.67559 3.72464 2.5 4.16667 2.5H5.83333M14.1667 2.5H15.8333C16.2754 2.5 16.6993 2.67559 17.0118 2.98816C17.3244 3.30072 17.5 3.72464 17.5 4.16667V5.83333M17.5 14.1667V15.8333C17.5 16.2754 17.3244 16.6993 17.0118 17.0118C16.6993 17.3244 16.2754 17.5 15.8333 17.5H14.1667M5.83333 17.5H4.16667C3.72464 17.5 3.30072 17.3244 2.98816 17.0118C2.67559 16.6993 2.5 16.2754 2.5 15.8333V14.1667"
        stroke="#282828"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.5009 7.99926C14.5007 7.82388 14.4544 7.65163 14.3666 7.4998C14.2789 7.34796 14.1527 7.22187 14.0008 7.13418L10.5005 5.13399C10.3484 5.04621 10.176 5 10.0004 5C9.82488 5 9.65242 5.04621 9.50038 5.13399L6.00005 7.13418C5.84816 7.22187 5.72201 7.34796 5.63424 7.4998C5.54648 7.65163 5.50018 7.82388 5.5 7.99926V11.9996C5.50018 12.175 5.54648 12.3473 5.63424 12.4991C5.72201 12.651 5.84816 12.777 6.00005 12.8647L9.50038 14.8649C9.65242 14.9527 9.82488 14.9989 10.0004 14.9989C10.176 14.9989 10.3484 14.9527 10.5005 14.8649L14.0008 12.8647C14.1527 12.777 14.2789 12.651 14.3666 12.4991C14.4544 12.3473 14.5007 12.175 14.5009 11.9996V7.99926Z"
        stroke="#282828"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.6499 7.49951L10.0003 9.99975M10.0003 9.99975L14.3507 7.49951M10.0003 9.99975V15.0002"
        stroke="#282828"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
